export const UI_ROOT_ELEMENT_ID = 'content';
